import { all } from "redux-saga/effects";
import { userMetaSaga } from "./userMeta";
import { sickLeaveSaga } from "./sickLeave";

export default function* rootSaga() {
  yield all([userMetaSaga(), sickLeaveSaga()]);
}
